import { HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutUpdateCredentialsDialog extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelConfirmationDialog: Label;
    panel1: Panel;
    updateCredentialsDialog: Label;
}
